export const DbEntity = {
    Event: 'event',
    ToolUser: 'tool_user',
    ToolUserDocument: 'tool_user_document',
    SiteAccount: 'site_account',
    Bet: 'bet',
    BetFail: 'bet_fail',
    BetOrder: 'bet_order',
    WlTransaction: 'wl_transaction',
    BetSettlement: 'bet_settlement',
    Site: 'site',
    AppAlert: 'app_alert',
    PageVisitHistory: 'page_visit_history',
    Bot: 'bot',
    Audit: 'audit',
} as const;

export type DbEntityName = (typeof DbEntity)[keyof typeof DbEntity];
